import { RootState } from "store/store";
import { ContractsStateSlice } from "store/types/contractsSlice.types";

export const getContractsSlice = (state: RootState): ContractsStateSlice => state.contracts;

export const getContractList = (state: RootState): ContractsStateSlice["list"] => getContractsSlice(state).list;

export const getSelectedContractId = (state: RootState): ContractsStateSlice["selectedContractId"] =>
  getContractsSlice(state).selectedContractId;

export const getContractDropdownOptions = (state: RootState) => {
  const contracts = getContractList(state);
  return contracts.map((item) => ({
    label: `${item.organization} (${item.name})`,
    value: item.name as string,
  }));
};
